// extracted by mini-css-extract-plugin
export default {"form-buttons":"FormFooter_form-buttons__XPgIJ","form-button-icons":"FormFooter_form-button-icons__OoNVV","btn-with-margin":"FormFooter_btn-with-margin__z3IKk"};